import {
  Flex, FormControl, FormLabel,
  Radio,
  RadioGroup, Text, useColorModeValue, VStack
} from "@chakra-ui/react";
import { apiurl } from "APIURL";
import axios from "axios";
import Card from "components/card/Card";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getAnswers, setGlobalAnswers } from "redux/slices/answersSlice";
import { selectCurrentTest } from "redux/slices/currentTestSlice";
import {
  selectUserAnswersData,
  setUserAnswers
} from "redux/slices/userAnswersSlice";
import { getProfileData } from "redux/slices/userSlice";
import { Answer, Question } from "types";

export default function SingleQuestion({
  addedOn,
  content,
  id,
  lastModifiedOn,
  questionTypeId,
  responseTimeout,
  testId,
  prevTimeout,
}: Question & {
  prevTimeout: number;
}) {
  const { currTest, index, questions } = useAppSelector(selectCurrentTest);
  const user = useAppSelector(getProfileData);
  const dispatch = useAppDispatch();
  const userAnswers = useAppSelector(selectUserAnswersData).answers;
  const [answer, setAnswer] = useState<Answer>(null);
  const [answers, setAnswers] = useState([]);
  const textColor = useColorModeValue("navy.700", "white");
  const [value, setValue] = React.useState(null);
  const [seconds, setSeconds] = useState(responseTimeout + prevTimeout);
  console.log(answer);
  const submitAnswer = async (val: string) => {
    setDisable(true);
    const res = await axios.post(`${apiurl}/answer/answerQuestion`, {
      answer: {
        connect: {
          id: parseInt(val),
        },
      },
      question: {
        connect: {
          id: id,
        },
      },
      user: {
        connect: {
          id: user.userId,
        },
      },
    });

    dispatch(setUserAnswers([...userAnswers, res.data]));
    console.log({ userAnswers });
  };
  const globalAnswers = useAppSelector(getAnswers).answers;
  const history = useHistory();
  const [disable, setDisable] = useState(false);
  React.useEffect(() => {
    const disableOnTimeout = (timeout: number) => {
      setTimeout(() => setDisable(true), timeout * 500);
    };
    console.log({ disable });
    const getData = async (questionId: any) => {
      try {
        const res = await axios.get(`${apiurl}/answer/question/${questionId}`);
        setAnswers([...res.data]);
        dispatch(setGlobalAnswers([...globalAnswers, ...res.data]));
        console.log({ globalAnswers });
      } catch (error) {
        console.log(error);
      }
    };
    disableOnTimeout(responseTimeout + prevTimeout);
    getData(id);
  }, [id]);

  //setInterval(()=>setSeconds(seconds-1),1000)

  return (
    <Card>
      <Flex direction={{ base: "column" }} justify="center">
        <Flex flexDirection="column" justify="space-between" h="100%">
          <Flex
            justify="space-between"
            direction={{
              base: "row",
              md: "column",
              lg: "row",
              xl: "column",
              "2xl": "row",
            }}
            mb="auto"
          >
            <Flex
              alignItems={"center"}
              width="100%"
              justifyContent={"space-between"}
              direction="row"
            >
              <Text
                color={textColor}
                fontSize={{
                  base: "xl",
                  md: "lg",
                  lg: "lg",
                  xl: "lg",
                  "2xl": "md",
                  "3xl": "lg",
                }}
                mb="5px"
                fontWeight="bold"
                me="14px"
              >
                {content}
              </Text>
              <Text
                color="secondaryGray.600"
                fontSize={{
                  base: "sm",
                }}
                fontWeight="400"
                me="14px"
              >
                {seconds}
              </Text>
            </Flex>
          </Flex>
          <Flex
            align={{
              base: "center",
              md: "start",
              lg: "center",
              xl: "start",
              "2xl": "center",
            }}
            justify="space-between"
            direction={{
              base: "column",
              md: "column",
              lg: "row",
              xl: "column",
              "2xl": "row",
            }}
            mt="25px"
          >
            <FormControl as="fieldset">
              <FormLabel as="legend">Réponses</FormLabel>
              <RadioGroup
                isDisabled={disable}
                value={value}
                onChange={(val: string) => submitAnswer(val)}
              >
                <VStack alignItems={"start"} spacing="24px">
                  {answers &&
                    answers.map(
                      (answer: {
                        id: { toString: () => any };
                        content: any;
                      }) => (
                        <Radio
                          disabled={disable}
                          colorScheme={"brandScheme"}
                          value={answer.id.toString()}
                        >
                          {answer.content}
                        </Radio>
                      )
                    )}
                </VStack>
              </RadioGroup>
            </FormControl>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}
